/* ==========================================================================
   VENDRA — wishlist, quick add (AJAX), карусель новинок.
   Только интерактив, без библиотек и без рендер-анимаций.
   ========================================================================== */
(function () {
  'use strict';

  var WISHLIST_KEY = 'vnd-wishlist';
  var reduceMotion =
    typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ------------------------------ Wishlist ------------------------------ */
  function loadWishlist() {
    try {
      return new Set(JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'));
    } catch (e) {
      return new Set();
    }
  }

  function saveWishlist(set) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(Array.from(set)));
    } catch (e) {
      /* no-op */
    }
  }

  function initWishlist() {
    var list = loadWishlist();
    document.querySelectorAll('[data-vnd-wishlist]').forEach(function (btn) {
      var id = btn.getAttribute('data-vnd-wishlist');
      if (list.has(id)) {
        btn.classList.add('is-on');
        btn.setAttribute('aria-pressed', 'true');
      }
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (list.has(id)) {
          list.delete(id);
          btn.classList.remove('is-on');
          btn.setAttribute('aria-pressed', 'false');
        } else {
          list.add(id);
          btn.classList.add('is-on');
          btn.setAttribute('aria-pressed', 'true');
          btn.classList.add('is-pop');
          setTimeout(function () {
            btn.classList.remove('is-pop');
          }, 350);
        }
        saveWishlist(list);
      });
    });
  }

  /* --------------------------- Quick add --------------------------- */
  function notifyCart(totalQuantity) {
    try {
      var evt = new CustomEvent('shopify:cart:lines-update', {
        detail: { action: 'add', context: 'vendra-card' },
        bubbles: true,
      });
      evt.action = 'add';
      evt.promise = Promise.resolve({
        cart: { totalQuantity: totalQuantity || 0 },
        detail: { itemCount: totalQuantity || 0 },
      });
      document.dispatchEvent(evt);
    } catch (e) {
      /* no-op */
    }
  }

  function initQuickAdd() {
    document.querySelectorAll('[data-vnd-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.dataset.loading === '1') return;
        btn.dataset.loading = '1';
        var variantId = btn.getAttribute('data-vnd-add');
        var span = btn.querySelector('span');
        var original = span ? span.textContent : 'Quick add';
        if (span) span.textContent = 'Adding…';

        fetch(routesRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            return fetch(routesRoot() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
              return r.ok ? r.json() : { total_quantity: 0 };
            });
          })
          .then(function (cart) {
            if (span) span.textContent = btn.getAttribute('data-vnd-added') || 'Added';
            btn.classList.add('is-added');
            notifyCart(cart && cart.total_quantity);
            setTimeout(function () {
              if (span) span.textContent = original;
              btn.classList.remove('is-added');
              delete btn.dataset.loading;
            }, 1600);
          })
          .catch(function () {
            if (span) span.textContent = original;
            delete btn.dataset.loading;
          });
      });
    });
  }

  /* --------------------------- Carousel --------------------------- */
  function initCarousel() {
    document.querySelectorAll('[data-vnd-carousel]').forEach(function (track) {
      var wrap = track.closest('.vnd-arrivals__wrap');
      if (!wrap) return;
      var prev = wrap.querySelector('[data-vnd-prev]');
      var next = wrap.querySelector('[data-vnd-next]');

      function step() {
        var item = track.querySelector('[data-vnd-slide], .vnd-arrivals__item');
        var w = item ? item.getBoundingClientRect().width + 18 : 280;
        return Math.max(w * 2, 280);
      }

      function update() {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 4;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft >= max;
      }

      var behavior = reduceMotion ? 'auto' : 'smooth';
      if (prev)
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: behavior });
        });
      if (next)
        next.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: behavior });
        });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
      setTimeout(update, 600);
    });
  }

  function boot() {
    initWishlist();
    initQuickAdd();
    initCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
